import { RadioTheme } from '../types';
import { colors } from '../constants/colors';

export const radio: RadioTheme = {
  checked: {
    colorByStatus: {
      disabled: `${colors.jlMoneyGreyLight}`,
      default: `${colors.jlMoneyGreyDark}`,
      valid: `${colors.jlMoneyGreyDark}`,
      error: `${colors.jlMoneyRed}`,
    },
    boxShadow: `0 0 0 1px ${colors.jlMoneyGreyDark}`,
    radioBgColor: `${colors.jlMoneyGreyDark}`,
    bgColor: 'transparent',
  },
  colorByStatus: {
    disabled: `${colors.jlMoneyGreyLight}`,
    default: `${colors.jlMoneyGreyDark}`,
    valid: `${colors.jlMoneyGreyDark}`,
    error: `${colors.jlMoneyRed}`,
  },
  hover: {
    boxShadow: `0 0 0 1px ${colors.jlMoneyGreyDark}`,
    borderColor: `${colors.jlMoneyGreyDark}`,
    bgColor: `${colors.jlMoneyGreenLight}`,
  },
  fieldBorderRadius: '2px',
};
